import { useContext } from "react";
import { AppContext } from "../context/AppContext";

const useCtx = () => {
    const ctx = useContext(AppContext);

    return ctx;
};

export default useCtx;
